<template>
  <div id>
    <base-header class="bg-primary pb-6 pt-0">
      <div class="row align-items-center pb-2">
        <div class="col-lg-6 col-7">
          <breadcrumb :link="[{ name: 'Quản lý Sản phẩm2', active: true }]"></breadcrumb>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6 pb-4 bg-lighter">
      <block :nobody="true" ref="bproduct" class="soft-control">
        <control-panel
          :countChecked="countChecked"
          @doAddNew="handleCreate"
          @doEdit="handleUpdate"
          @search="handleSearch"
          @copy="handleCopy"
          :help="handleHelp"
          @doDelete="handleDelete"
        ></control-panel>
        <b-card :no-body="true" class="p-2 mb-0">
          <b-tabs>
            <b-tab title="Sản phẩm" @click="typeSelected = 'ACTIVE'">
              <product
                @tbRowClicked="productRowClicked"
                @countCheckedChange="countCheckedChange"
                @reloadProductInfo="reloadProductInfo"
                @specProductSelected="specProductSelected"
                ref="productActive"
                type="ACTIVE"
              ></product>
            </b-tab>
            <b-tab title="Sản phẩm thử" @click="typeSelected = 'SAMPLE'">
              <product
                @tbRowClicked="productRowClicked"
                @countCheckedChange="countCheckedChange"
                ref="productSample"
                type="SAMPLE"
              ></product>
            </b-tab>
          </b-tabs>
        </b-card>
      </block>
      <block :nobody="true" ref="binfoProduct" class="soft-control mb-3">
        <b-row class=" p-2">
          <b-col md="9">
            <b-card :no-body="true" class="p-2 mb-0">
              <product-info @reloadProductInfo="reloadProductInfo" ref="productInfos"></product-info>
            </b-card>
          </b-col>
          <b-col md="3">
            <b-card :no-body="true" class="p-2 mb-0">
              <img
                class="img-fluid"
                v-holder="{
                  text: 'Hình đại diện'
                }"
                @error="$imgHolder"
                :src="this.$mediaURI + info.avatar"
              />
            </b-card>
          </b-col>
        </b-row>
      </block>
    </div>
    <event @doAdd="handleCreate" @doEdit="handleUpdate"></event>
  </div>
</template>
<script>
import Product from './__Product';
import ProductInfo from './__ProductInfo';
export default {
  name: 'product-manage2',
  components: {
    Product,
    ProductInfo
  },
  data() {
    return {
      countChecked: 0,
      listQuery: {
        page: 1,
        limit: 30,
        total: 0
      },
      lastIndexCustomerSelected: 0,
      typeSelected: 'ACTIVE',
      info: {},
      tableData: [],
      fields: []
    };
  },
  methods: {
    productTabSelect() {
      if (this.typeSelected == 'ACTIVE') return this.$refs.productActive;
      return this.$refs.productSample;
    },
    reloadProductInfo() {
      this.$refs.productInfos.fetchData();
    },
    handleSearch(keyword) {
      this.productTabSelect().handleSearch(keyword);
      this.$refs.productSample.handleSearch(keyword);
    },
    handleUpdate() {
      this.productTabSelect().handleUpdate();
    },
    handleCreate() {
      this.productTabSelect().handleCreate();
    },
    handleCopy() {
      this.productTabSelect().handleCopy();
    },
    handleHelp() {
      alert('help');
    },
    handleDelete() {
      this.productTabSelect().handleDelete();
    },
    countCheckedChange(countChecked) {
      this.countChecked = countChecked;
    },
    productRowClicked(item) {
      this.info = item;
      // this.$refs.productInfos.setData(this.info);
    },
    specProductSelected(product, item, index) {
      this.$refs.productInfos.setData(product, item);
    }
  },
  watch: {
    typeSelected: function() {
      this.countChecked = this.productTabSelect().countChecked;
      this.info = this.productTabSelect().info;
      //this.$refs.productInfos.setData(this.info);
    }
  }
};
</script>
<style lang="scss"></style>
